<template>
  <div
    v-if="!showQuizCompletion"
    class="wrapper"
  >
    <main class="main">
      <div class="container">

        <ProgressBar
          :current="cumulativeCourseProgress"
          :total="totalCourseQuestionsInCourse"
          :show-progress="shouldShowProgress"
          @back-clicked="handleProgressBarBackClick"
          :class="{ 'status-bar--quiz': shouldApplyQuizStyle }"
        />

        <!--Компонент стартовый экран-->
        <StartWindow
          v-if="!selectedCourseType && !showQuizCompletion && !isPetChosen"
          @choose-pet="showPetSelection"
        />
        <!--Компонент стартовый экран-->

        <!-- Компонент Выбор Питомца -->
        <PetSelectionPage
          v-if="!selectedCourseType && !showQuizCompletion && isPetChosen"
          @setupComplete="handlePetSelectionComplete"
        />
        <!-- Компонент Выбор Питомца -->

        <!-- Статья -->
        <component
          v-if="courseStructure && currentModule && !isLoading && !error && !showQuizCompletion && currentModule.type === 'content'"
          :is="getLessonComponent(currentModule.frontend_page_key)"
          :moduleData="currentModule"
          @goToQuiz="nextModule"
        />
        <!-- Статья -->

        <!-- Квиз -->
        <div
          v-if="courseStructure && currentModule && !isLoading && !error && !showQuizCompletion && currentModule.type === 'quiz'"
          class="quiz"
        >
          <QuizComponent
            ref="quizComponent"
            :quiz-ref="currentModule.quiz_data_ref"
            :current-question-index="quizQuestionIndexes[currentModule.quiz_data_ref] || 0"
            :selected-course-type="selectedCourseType"
            @quiz-topic-completed="handleQuizCompleted"
            @progress-updated="handleQuizProgressUpdate"
            @question-index-updated="handleQuestionIndexUpdate"
            @exit-quiz="handleExitQuiz"
          />
        </div>
        <!-- Квиз -->

        <!-- Модалка завершения -->
        <div v-if="showExitConfirmation" class="modal" :class="{ active: isExitConfirmationActive }">
          <div class="modal-overlay"></div>
          <div class="modal-content">
            <div class="modal-content__block">
              <div class="modal-content__avatar">
                <img src="/static/img/avatar/unhappy.png" alt="">
              </div>
              <h2 class="modal-content__title red">Вы еще не закончили&nbsp;игру</h2>
              <p class="modal-content__text">Вы точно хотите закончить игру?<br>Ваш прогресс не сохранится.</p>
              <div class="modal-content__buttons">
                <button @click="confirmExit" class="btn">Выйти</button>
                <button @click="cancelExit" class="btn btn--green">Продолжить</button>
              </div>
            </div>
          </div>
        </div>
        <!-- Модалка завершения -->

        <div v-if="isLoading && !showQuizCompletion" class="loading-indicator">
          Загрузка курса...
        </div>

        <div v-if="error && !showQuizCompletion" class="error-message">
          <p>Ошибка загрузки курса: {{ error }}</p>
          <button @click="resetToSelection">Выбрать другой курс</button>
        </div>
      </div>
    </main>
  </div>

  <!-- Quiz Completion Page -->
  <QuizCompletionPage
    v-if="showQuizCompletion"
    :mindbox-data="mindboxData"
    @close="showQuizCompletion = false"
    @return-to-main="handleReturnToMain"
  />
</template>

<script>
import axios from 'axios';
import StartWindow from '@/components/StartWindow/StartWindow.vue'
import { getOrCreateDeviceUUID } from '@/utils/uuid'
import { saveSession, loadSession, clearSession } from '@/services/sessionService'

import QuizComponent from '../Quiz.vue';
import InterstitialPage from '../InterstitialPage.vue';
import LessonCatsTopic1 from '../LessonCatsTopic1.vue'
import LessonCatsTopic2 from '../LessonCatsTopic2.vue'
import LessonCatsTopic3 from '../LessonCatsTopic3.vue'
import LessonCatsTopic4 from '../LessonCatsTopic4.vue'
import LessonCatsTopic5 from '../LessonCatsTopic5.vue'
import LessonDogsTopic1 from '../LessonDogsTopic1.vue'
import LessonDogsTopic2 from '../LessonDogsTopic2.vue'
import LessonDogsTopic3 from '../LessonDogsTopic3.vue'
import LessonDogsTopic4 from '../LessonDogsTopic4.vue'
import LessonDogsTopic5 from '../LessonDogsTopic5.vue'
import LessonCatsTopic1FutureOwner from '../LessonCatsTopic1FutureOwner.vue'
import LessonDogsTopic1FutureOwner from '../LessonDogsTopic1FutureOwner.vue'
import PetSelectionPage from '../PetSelectionPage.vue'
import QuizCompletionPage from '../QuizCompletionPage.vue'

const API_BASE_URL = process.env.VUE_APP_API_BASE_URL || '';

import ProgressBar from '../ProgressBar.vue';
import analyticsTracking from '@/mixins/analyticsTracking.js';

export default {
  name: 'App',
  components: {
    StartWindow,
    ProgressBar,
    QuizComponent,
    InterstitialPage,
    LessonCatsTopic1,
    LessonCatsTopic2,
    LessonCatsTopic3,
    LessonCatsTopic4,
    LessonCatsTopic5,
    LessonDogsTopic1,
    LessonDogsTopic2,
    LessonDogsTopic3,
    LessonDogsTopic4,
    LessonDogsTopic5,
    LessonCatsTopic1FutureOwner,
    LessonDogsTopic1FutureOwner,
    PetSelectionPage,
    QuizCompletionPage
  },
  mixins: [analyticsTracking],
  data() {
    return {
      isPetChosen: false,
      userId: getOrCreateDeviceUUID(),
      selectedCourseType: null,
      courseStructure: null,
      currentModuleIndex: 0,
      isLoading: false,
      error: null,
      apiBaseUrl: API_BASE_URL,
      totalCourseQuestionsInCourse: 0,
      cumulativeCourseProgress: 0,
      quizModuleQuestionCounts: {},
      questionsInCompletedModules: 0,
      // Track current question index for each quiz
      quizQuestionIndexes: {}, // { quizRef: currentQuestionIndex }
      // Mindbox data from pet selection
      mindboxData: {
        typeClient: undefined,
        typePet: '',
        initialVariant: 'standard'
      },
      // Quiz completion page control
      showQuizCompletion: false,
      quizCompleted: false,
      showExitConfirmation: false,
      isExitConfirmationActive: false
    };
  },
  computed: {
    currentModule() {
      if (this.courseStructure && this.courseStructure.modules && this.currentModuleIndex < this.courseStructure.modules.length) {
        return this.courseStructure.modules[this.currentModuleIndex];
      }
      return null;
    },
    totalModules() {
      return this.courseStructure && this.courseStructure.modules ? this.courseStructure.modules.length : 0;
    },
    currentStage() {
      // Определяем номер этапа на основе текущего модуля
      if (!this.currentModule) return 1;
      
      // Если это квиз, пытаемся извлечь номер из quiz_data_ref
      if (this.currentModule.type === 'quiz' && this.currentModule.quiz_data_ref) {
        const topicMatch = this.currentModule.quiz_data_ref.match(/topic(\d+)/);
        if (topicMatch) {
          return parseInt(topicMatch[1]) || 1;
        }
      }
      
      // Если это статья, пытаемся извлечь номер из frontend_page_key
      if (this.currentModule.type === 'content' && this.currentModule.frontend_page_key) {
        const topicMatch = this.currentModule.frontend_page_key.match(/topic(\d+)/);
        if (topicMatch) {
          return parseInt(topicMatch[1]) || 1;
        }
      }
      
      // Fallback: вычисляем приблизительно по индексу модуля
      return Math.floor(this.currentModuleIndex / 2) + 1;
    },
    shouldShowProgress() {
      // Скрываем прогресс на StartWindow и PetSelectionPage
      const isStartWindow = !this.selectedCourseType && !this.showQuizCompletion && !this.isPetChosen;
      const isPetSelectionPage = !this.selectedCourseType && !this.showQuizCompletion && this.isPetChosen;
      return !(isStartWindow || isPetSelectionPage);
    },
    shouldApplyQuizStyle() {
      // Применяем стиль квиза для страницы выбора питомца и для самих квизов
      const isPetSelectionPage = !this.selectedCourseType && !this.showQuizCompletion && this.isPetChosen;
      const isQuizModule = this.currentModule && this.currentModule.type === 'quiz';
      return isPetSelectionPage || isQuizModule;
    }
  },
  watch: {
    currentModuleIndex: {
      handler(newIndex) {
        if (!this.courseStructure || !this.courseStructure.modules) {
          this.questionsInCompletedModules = 0;
          this.cumulativeCourseProgress = 0;
          return;
        }

        let completedQuestions = 0;
        for (let i = 0; i < newIndex; i++) {
          const module = this.courseStructure.modules[i];
          if (module.type === 'quiz' && this.quizModuleQuestionCounts[module.quiz_data_ref]) {
            completedQuestions += this.quizModuleQuestionCounts[module.quiz_data_ref];
          }
        }
        this.questionsInCompletedModules = completedQuestions;

        if (this.currentModule && this.currentModule.type !== 'quiz') {
          // Для статей: показываем количество завершенных квизов до этой статьи
          this.cumulativeCourseProgress = this.questionsInCompletedModules+1;
        } else if (!this.currentModule) {
          if (this.totalCourseQuestionsInCourse > 0) {
            this.cumulativeCourseProgress = this.totalCourseQuestionsInCourse;
          }
        } else if (this.currentModule && this.currentModule.type === 'quiz') {
          // Для квизов: стартуем с количества завершенных вопросов до этого квиза
          // Во время прохождения квиза прогресс будет обновляться через handleQuizProgressUpdate
          this.cumulativeCourseProgress = this.questionsInCompletedModules;
        }
        this.saveProgressToLocalStorage();
      },
    },
    courseStructure(newVal) {
      if (newVal && newVal.modules) {
        this._initializeCourseProgressData();
      } else {
        this.clearProgressFromLocalStorage();
      }
    },
    selectedCourseType() {
      this.saveProgressToLocalStorage();
    },
    cumulativeCourseProgress() {
      this.saveProgressToLocalStorage();
    },
    totalCourseQuestionsInCourse() {
      this.saveProgressToLocalStorage();
    },
    quizModuleQuestionCounts: {
      handler() {
        this.saveProgressToLocalStorage();
      },
      deep: true
    },
    questionsInCompletedModules() {
      this.saveProgressToLocalStorage();
    },
    quizQuestionIndexes: {
      handler() {
        this.saveProgressToLocalStorage();
      },
      deep: true
    },
    // Add watcher for mindboxData to save it when it changes
    mindboxData: {
      handler() {
        this.saveProgressToLocalStorage();
      },
      deep: true
    }
  },
  created() {
    // Загружаем прогресс из localStorage
    this.loadProgressFromLocalStorage();
    // Также пытаемся загрузить сессию из Redis
    this.loadSessionFromRedis();

    // Проверяем, находился ли пользователь на странице завершения
    const completionFormReached = localStorage.getItem('completion_form_reached');
    if (completionFormReached === 'true') {
      this.showQuizCompletion = true;
    }
  },
  methods: {
    showPetSelection() {
      this.isPetChosen = true;
    },


    getLocalStorageKey() {
      if (!this.userId) return null;
      return `courseProgress_${this.userId}`;
    },

    saveProgressToLocalStorage() {
      const key = this.getLocalStorageKey();
      if (!key) return;

      // Save basic progress data including mindboxData if pet is chosen
      const progressData = {
        selectedCourseType: this.selectedCourseType,
        currentModuleIndex: this.currentModuleIndex,
        cumulativeCourseProgress: this.cumulativeCourseProgress,
        totalCourseQuestionsInCourse: this.totalCourseQuestionsInCourse,
        quizModuleQuestionCounts: this.quizModuleQuestionCounts,
        questionsInCompletedModules: this.questionsInCompletedModules,
        quizQuestionIndexes: this.quizQuestionIndexes,
        mindboxData: this.mindboxData,
        isPetChosen: this.isPetChosen
      };

      // Don't save course-specific progress if course is not loaded yet
      if (!this.selectedCourseType || !this.courseStructure) {
        // But still save pet selection data
        const basicData = {
          mindboxData: this.mindboxData,
          isPetChosen: this.isPetChosen
        };
        localStorage.setItem(key, JSON.stringify(basicData));
        return;
      }

              localStorage.setItem(key, JSON.stringify(progressData));
    },

    loadProgressFromLocalStorage() {
      const key = this.getLocalStorageKey();
      if (!key) return;

      const savedData = localStorage.getItem(key);
      if (savedData) {
        try {
          const progressData = JSON.parse(savedData);

          this.selectedCourseType = progressData.selectedCourseType;
          this.quizModuleQuestionCounts = progressData.quizModuleQuestionCounts || {};
          this.totalCourseQuestionsInCourse = progressData.totalCourseQuestionsInCourse || 0;
          this.questionsInCompletedModules = progressData.questionsInCompletedModules || 0;
          this.cumulativeCourseProgress = progressData.cumulativeCourseProgress || 0;
          this.currentModuleIndex = progressData.currentModuleIndex || 0;
          this.quizQuestionIndexes = progressData.quizQuestionIndexes || {};
          this.mindboxData = progressData.mindboxData || {
            typeClient: undefined,
            typePet: '',
            initialVariant: 'standard'
          };
          
          // Load pet selection state
          if (progressData.isPetChosen !== undefined) {
            this.isPetChosen = progressData.isPetChosen;
          }

          if (this.selectedCourseType) {
            if (!this.courseStructure) {
              this.fetchCourseStructure();
            }
          }
        } catch (e) {
          localStorage.removeItem(key);
        }
      }
    },
    clearProgressFromLocalStorage() {
      const key = this.getLocalStorageKey();
      if (key) {
        localStorage.removeItem(key);
      }
      
      // Также очищаем сессию из Redis
      clearSession().catch(() => {
        // Could not clear session from Redis, but continue
      });
    },

    selectCourse(courseType) {
      this.userId = getOrCreateDeviceUUID();

      this.selectedCourseType = courseType;
      this.courseStructure = null;
      this.currentModuleIndex = 0;
      this.error = null;
      this.cumulativeCourseProgress = 0;
      this.quizModuleQuestionCounts = {};
      this.questionsInCompletedModules = 0;
      this.quizQuestionIndexes = {};
      this.fetchCourseStructure();
    },
    async fetchCourseStructure() {
      this.isLoading = true;
      try {
        const response = await axios.get(`${this.apiBaseUrl}/api/quiz/${this.selectedCourseType}_course`);
        this.courseStructure = response.data;
        if (!this.courseStructure || !this.courseStructure.modules) {
          this.error = "Структура курса не найдена или некорректна.";
        }
      } catch (err) {
        this.error = err.response?.data?.detail || err.message || "Не удалось загрузить структуру курса.";
      } finally {
        this.isLoading = false;
      }
    },

    async _initializeCourseProgressData() {
      if (!this.courseStructure || !this.courseStructure.modules) return;
      this.isLoading = true;

      const quizModules = this.courseStructure.modules.filter(module => module.type === 'quiz');
      if (quizModules.length === 0) {
        this.totalCourseQuestionsInCourse = 0;
        this.cumulativeCourseProgress = 0;
        this.quizModuleQuestionCounts = {};
        this.questionsInCompletedModules = 0;
        this.isLoading = false;
        this.saveProgressToLocalStorage();
        this.$nextTick(() => {
          const tempIndex = this.currentModuleIndex;
          this.currentModuleIndex = -1;
          this.$nextTick(() => {
            this.currentModuleIndex = tempIndex;
          });
        });
        return;
      }

      const promises = quizModules.map(module =>
        axios.get(`${this.apiBaseUrl}/api/quiz/${module.quiz_data_ref}`)
          .then(response => ({
            quiz_ref: module.quiz_data_ref,
            count: response.data.questions ? response.data.questions.length : 0
          }))
          .catch(() => {
            return {quiz_ref: module.quiz_data_ref, count: 0};
          })
      );

      try {
        const results = await Promise.all(promises);
        let totalQuestions = 0;
        const counts = {};
        results.forEach(result => {
          counts[result.quiz_ref] = result.count;
          totalQuestions += result.count;
        });
        this.quizModuleQuestionCounts = counts;
        this.totalCourseQuestionsInCourse = totalQuestions;

        let initialCompletedQuestions = 0;
        for (let i = 0; i < this.currentModuleIndex; i++) {
          const module = this.courseStructure.modules[i];
          if (module.type === 'quiz' && this.quizModuleQuestionCounts[module.quiz_data_ref]) {
            initialCompletedQuestions += this.quizModuleQuestionCounts[module.quiz_data_ref];
          }
        }
        this.questionsInCompletedModules = initialCompletedQuestions;
        if (this.currentModule && this.currentModule.type !== 'quiz') {
          this.cumulativeCourseProgress = this.questionsInCompletedModules;
        } else {
          this.cumulativeCourseProgress = this.questionsInCompletedModules;
        }

      } catch {
        this.error = "Не удалось рассчитать общий прогресс курса.";
        this.totalCourseQuestionsInCourse = 0;
        this.quizModuleQuestionCounts = {};
        this.questionsInCompletedModules = 0;
        this.cumulativeCourseProgress = 0;
        this.saveProgressToLocalStorage();
      } finally {
        this.isLoading = false;
        const tempIndex = this.currentModuleIndex;
        this.currentModuleIndex = -1;
        this.$nextTick(() => {
          this.currentModuleIndex = tempIndex;
        });
      }
    },

    handleQuizCompleted() {
      // Check if this is the last module in the course
      if (this.currentModuleIndex < this.totalModules - 1) {
        // Not the last module, continue to next module
        this.currentModuleIndex++;
        // Прокрутка к началу при переходе к следующему модулю
        this.$nextTick(() => {
          this.scrollToTop();
        });
      } else {
        // This is the last module, show completion page for data verification
        this.showQuizCompletion = true;
        // Сохраняем состояние в localStorage
        localStorage.setItem('completion_form_reached', 'true');
        this.$nextTick(() => {
          this.scrollToTop();
        });
      }
    },

    nextModule() {
      if (this.currentModuleIndex < this.totalModules - 1) {
        this.currentModuleIndex++;
        // Прокрутка к началу при переходе к следующему модулю
        this.$nextTick(() => {
          this.scrollToTop();
        });
      }
    },
    previousModule() {
      if (this.currentModuleIndex > 0) {
        this.currentModuleIndex--;
        // Прокрутка к началу при переходе к предыдущему модулю
        this.$nextTick(() => {
          this.scrollToTop();
        });
      }
    },
    goBackOrExitQuiz() {
      if (this.currentModule && this.currentModule.type === 'quiz') {
        if (this.currentModuleIndex > 0) {
          this.previousModule();
        } else {
          this.selectedCourseType = null;
        }
      } else if (this.currentModuleIndex > 0) {
        this.previousModule();
      } else {
        this.selectedCourseType = null;
        this.courseStructure = null;
        this.currentModuleIndex = 0;
        this.totalCourseQuestionsInCourse = 0;
        this.cumulativeCourseProgress = 0;
        this.quizModuleQuestionCounts = {};
        this.questionsInCompletedModules = 0;
        this.quizQuestionIndexes = {};
        this.clearProgressFromLocalStorage();
      }
    },
    getLessonComponent(pageKey) {
      const lessons = {
        'cats_content_topic1': LessonCatsTopic1,
        'cats_content_topic2': LessonCatsTopic2,
        'cats_content_topic3': LessonCatsTopic3,
        'cats_content_topic4': LessonCatsTopic4,
        'cats_content_topic5': LessonCatsTopic5,
        'dogs_content_topic1': LessonDogsTopic1,
        'dogs_content_topic2': LessonDogsTopic2,
        'dogs_content_topic3': LessonDogsTopic3,
        'dogs_content_topic4': LessonDogsTopic4,
        'dogs_content_topic5': LessonDogsTopic5,
      };

      if (!pageKey) {
        return 'InterstitialPage';
      }

      // Для будущих владельцев показываем специальные компоненты для первой темы
      if (this.mindboxData.initialVariant === 'wants_to_get') {
        if (pageKey === 'cats_content_topic1') {
          return LessonCatsTopic1FutureOwner;
        } else if (pageKey === 'dogs_content_topic1') {
          return LessonDogsTopic1FutureOwner;
        }
      }

      return lessons[pageKey] || 'InterstitialPage'
    },
    handleQuizProgressUpdate({current}) {
      if (this.currentModule && this.currentModule.type === 'quiz') {
        this.cumulativeCourseProgress = this.questionsInCompletedModules + current;
              }
    },
    async loadSessionFromRedis() {
      try {
        const sessionData = await loadSession();
        if (sessionData) {
          
          // Восстанавливаем данные из Redis
          this.mindboxData = {
            typeClient: sessionData.typeClient,
            typePet: sessionData.typePet,
            initialVariant: sessionData.initialVariant
          };
          
          // Если есть данные о питомце, значит питомец был выбран
          if (sessionData.typePet) {
            this.isPetChosen = true;
          }
          
          // Также сохраняем в localStorage для совместимости
          this.saveProgressToLocalStorage();
        }
      } catch (error) {
        // Продолжаем работу без сессии из Redis
      }
    },
    async handlePetSelectionComplete(data) {
      // Store Mindbox data for later use
      this.mindboxData = {
        typeClient: data.mindboxTypeClient,
        typePet: data.mindboxTypePet,
        initialVariant: data.initialVariant
      };

      // Сохраняем сессию в Redis
      try {
        await saveSession({
          typePet: data.mindboxTypePet,
          typeClient: data.mindboxTypeClient,
          initialVariant: data.initialVariant
        });
      } catch (error) {
        // Продолжаем работу даже если Redis не работает
      }

      // Map courseType to the correct course selection
      this.selectCourse(data.courseType);

      // Прокрутка к началу при выборе курса
      this.$nextTick(() => {
        this.scrollToTop();
      });
    },
    resetToSelection() {
      this.selectedCourseType = null;
      this.courseStructure = null;
      this.currentModuleIndex = 0;
      this.totalCourseQuestionsInCourse = 0;
      this.cumulativeCourseProgress = 0;
      this.quizModuleQuestionCounts = {};
      this.questionsInCompletedModules = 0;
      this.quizQuestionIndexes = {};
      this.clearProgressFromLocalStorage();
    },
    finishCourse() {
      this.cumulativeCourseProgress = this.totalCourseQuestionsInCourse;
      this.selectedCourseType = null;
      this.courseStructure = null;
      this.currentModuleIndex = 0;
      this.totalCourseQuestionsInCourse = 0;
      this.cumulativeCourseProgress = 0;
      this.quizModuleQuestionCounts = {};
      this.questionsInCompletedModules = 0;
      this.quizQuestionIndexes = {};
      this.clearProgressFromLocalStorage();
    },
    goToNextModule() {
      if (this.currentModuleIndex < this.totalModules - 1) {
        this.currentModuleIndex++;
        // Прокрутка к началу при переходе к следующему модулю
        this.$nextTick(() => {
          this.scrollToTop();
        });
      }
    },
    handleQuestionIndexUpdate(index) {
      if (this.currentModule && this.currentModule.type === 'quiz') {
        this.quizQuestionIndexes[this.currentModule.quiz_data_ref] = index;
        
        // Добавляем скролл к верху при переходе между вопросами
        this.$nextTick(() => {
          this.scrollToTop();
        });
      }
    },
    handleExitQuiz() {
      if (this.currentModule && this.currentModule.type === 'quiz') {
        this.selectedCourseType = null;
        this.courseStructure = null;
        this.currentModuleIndex = 0;
        this.totalCourseQuestionsInCourse = 0;
        this.cumulativeCourseProgress = 0;
        this.quizModuleQuestionCounts = {};
        this.questionsInCompletedModules = 0;
        this.quizQuestionIndexes = {};
        this.clearProgressFromLocalStorage();
      }
    },
    handleProgressBarBackClick() {
      // Если находимся на стартовом экране, переходим на главную страницу
      const isStartWindow = !this.selectedCourseType && !this.showQuizCompletion && !this.isPetChosen;
      
      if (isStartWindow) {
        // Переход на главную страницу
        this.$router.push('/');
        return;
      }

      // В остальных случаях показываем модальное окно подтверждения выхода
      this.showExitConfirmation = true;

      // Добавляем класс active с небольшой задержкой для анимации
      this.$nextTick(() => {
        setTimeout(() => {
          this.isExitConfirmationActive = true;
        }, 50);
      });
    },
    handleCompletionGoBack() {
      this.showQuizCompletion = false;
      // Return to the current quiz (user can continue from where they left off)
    },
    handleDataConfirmed() {
      // Data has been confirmed and sent to Mindbox
      this.showQuizCompletion = false;

      // Continue with the original quiz completion logic
      if (this.currentModuleIndex < this.totalModules - 1) {
        this.currentModuleIndex++;
        // Прокрутка к началу при переходе к следующему модулю
        this.$nextTick(() => {
          this.scrollToTop();
        });
      } else {
        this.cumulativeCourseProgress = this.totalCourseQuestionsInCourse;
        this.selectedCourseType = null;
        this.courseStructure = null;
        this.currentModuleIndex = 0;
        this.totalCourseQuestionsInCourse = 0;
        this.cumulativeCourseProgress = 0;
        this.quizModuleQuestionCounts = {};
        this.questionsInCompletedModules = 0;
        this.quizQuestionIndexes = {};
        this.clearProgressFromLocalStorage();
      }
    },
    confirmExit() {
      // Отправляем событие выхода с номером этапа
      this.sendEventYM(
        'exit_click_btn',
        {
          'exit_click_button_param': this.currentStage
        }
      );
      
      // Сначала убираем класс active
      this.isExitConfirmationActive = false;

      // Затем через время анимации убираем модальное окно и выполняем выход
      setTimeout(() => {
        this.showExitConfirmation = false;

        // Полная очистка состояния для возврата к стартовому экрану
        this.isPetChosen = false;
        this.selectedCourseType = null;
        this.courseStructure = null;
        this.currentModuleIndex = 0;
        this.totalCourseQuestionsInCourse = 0;
        this.cumulativeCourseProgress = 0;
        this.quizModuleQuestionCounts = {};
        this.questionsInCompletedModules = 0;
        this.quizQuestionIndexes = {};
        this.clearProgressFromLocalStorage();

        // Прокрутка к началу при возврате к стартовому экрану
        this.$nextTick(() => {
          this.scrollToTop();
        });
      }, 300); // Время должно совпадать с длительностью анимации
    },
    cancelExit() {
      // Сначала убираем класс active
      this.isExitConfirmationActive = false;

      // Затем через время анимации убираем модальное окно
      setTimeout(() => {
        this.showExitConfirmation = false;
      }, 300); // Время должно совпадать с длительностью анимации
    },
    scrollToTop() {
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      });
    },
    handleReturnToMain() {
      // Скрываем страницу завершения квиза
      this.showQuizCompletion = false;

      // Сбрасываем все данные курса
      this.selectedCourseType = null;
      this.courseStructure = null;
      this.currentModuleIndex = 0;
      this.totalCourseQuestionsInCourse = 0;
      this.cumulativeCourseProgress = 0;
      this.quizModuleQuestionCounts = {};
      this.questionsInCompletedModules = 0;
      this.quizQuestionIndexes = {};

      // Сбрасываем данные о питомце, чтобы снова показать выбор
      this.isPetChosen = false;
      this.mindboxData = {
        typeClient: undefined,
        typePet: '',
        initialVariant: 'standard'
      };

      // Очищаем сохраненный прогресс
      this.clearProgressFromLocalStorage();

      // Прокрутка к началу
      this.$nextTick(() => {
        this.scrollToTop();
      });
    },
    resetToInitialState() {
      this.isPetChosen = false;
      this.selectedCourseType = null;
      this.courseStructure = null;
      this.currentModuleIndex = 0;
      this.totalCourseQuestionsInCourse = 0;
      this.cumulativeCourseProgress = 0;
      this.quizModuleQuestionCounts = {};
      this.questionsInCompletedModules = 0;
      this.quizQuestionIndexes = {};
      this.showQuizCompletion = false;
      this.mindboxData = {
        typeClient: undefined,
        typePet: '',
        initialVariant: 'standard'
      };
    }
  }
}
</script>

<style src="../../assets/styles/main.scss" lang="scss"></style>

<style scoped lang="scss">
.modal {
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: -1;
  opacity: 0;
  visibility: hidden;
  transition: $duration $timing-function;

  &.active {
    z-index: 100;
    opacity: 1;
    visibility: visible;
  }

  &-overlay {
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.50);
  }

  &-content {
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    max-height: 100vh;
    overflow-y: scroll;
    height: fit-content;
    padding: 49px 24px 24px;
    background-color: var(--white);
    border-radius: 32px 32px 0 0;

    &__block {
      display: flex;
      flex-direction: column;
      align-items: center;

      @media (min-width: $lg) {
        margin: 0 auto;
        width: 592px;
      }
    }

    &__avatar {
      margin-bottom: 12px;
      width: 120px;
      height: 120px;

      & img {
        width: 100%;
        height: 100%;
        aspect-ratio: 1 / 1;
        object-fit: contain;
      }
    }

    &__title {
      margin-bottom: 24px;
      max-width: 251px;
      color: var(--green);
      text-align: center;
      font-family: Dinprocondensed;
      font-size: 32px;
      font-style: normal;
      font-weight: 900;
      line-height: 94%;
      letter-spacing: -0.48px;
      text-transform: uppercase;

      &.red {
        color: var(--red);
      }
    }

    &__text {
      @include text-16-500;

      margin-bottom: 30px;
      line-height: 118.75%;
      text-align: center;
    }

    &__buttons {
      display: flex;
      margin-top: auto;
      gap: 10px;
      width: 100%;

      & button {
        width: 50%;
        flex-grow: 1;
        text-transform: none;
      }
    }
  }

  // Модалки правильно-неправильно
  &.modal--answer {
    & .modal {
      &-content {
        padding: 16px 16px 24px;

        &__avatar {
          margin-bottom: 9px;
        }

        &__title {
          margin-bottom: 28px;
          font-family: Dinprocondensed;
          font-size: 38px;
          font-style: normal;
          letter-spacing: -0.57px;
        }

        &__answer {
          margin-bottom: 40px;
          .quiz-options.quiz__multiple-choice {
            .quiz__option.selected {
              border-color: var(--green);
            }

            .quiz__option-icon {
              & svg {
                color: var(--green);
              }
            }
          }
        }
      }
    }
  }
}
</style>
